import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  buttons: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  footer: {
    borderTop: "1px solid ".concat(palette.shades[400]),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: '16px 32px'
  }
});
export default useStyles;